var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H11.1429V4.28571C11.1429 1.92 9.22286 0 6.85714 0C4.49143 0 2.57143 1.92 2.57143 4.28571V6H1.71429C0.771429 6 0 6.77143 0 7.71429V16.2857C0 17.2286 0.771429 18 1.71429 18H12C12.9429 18 13.7143 17.2286 13.7143 16.2857V7.71429C13.7143 6.77143 12.9429 6 12 6ZM4.28571 4.28571C4.28571 2.86286 5.43429 1.71429 6.85714 1.71429C8.28 1.71429 9.42857 2.86286 9.42857 4.28571V6H4.28571V4.28571ZM12 16.2857H1.71429V7.71429H12V16.2857ZM6.85714 13.7143C7.8 13.7143 8.57143 12.9429 8.57143 12C8.57143 11.0571 7.8 10.2857 6.85714 10.2857C5.91429 10.2857 5.14286 11.0571 5.14286 12C5.14286 12.9429 5.91429 13.7143 6.85714 13.7143Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d523e8c2f8aea3784595775586f3ecdc.svg";
export { ForwardRef as ReactComponent };